//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import axios from "axios";

export default {
  data() {
    return {
      PageMain: true,
      Step01: false,
      // MyImage: "../assets/board01.jpg",
      p01: require("../assets/p01.jpg"),
      p02: require("../assets/p02.jpg"),
      p03: require("../assets/p03.jpg"),
      p04: require("../assets/p04.jpg"),
      p05: require("../assets/p05.jpg"),
      p06: require("../assets/p06.jpg"),
      p07: require("../assets/p07.jpg"),
      p08: require("../assets/p08.jpg"),
      // subprocess_pic: require('../assets/subprocess.jpg')
      uniq: ""
    };
  },
  created() {
    this.chkAuthen("", "");
    this.uniq = this.create_UUID();
  },
  mounted() {
    // console.log(this.uniq)
  },
  methods: {
    ShowDetail(PageName) {
      this.PageMain = false;
      if (PageName == "Step01") {
        this.Step01 = true;
      }
    },
    goPage(routerName) {
      this.$router.push({
        name: routerName
      });
    },
    exitApp() {
      this.$q
        .dialog({
          title: "Confirm",
          message: "Do you want to Exit?",
          cancel: true,
          persistent: true
        })
        .onOk(() => {
          // console.log('>>>> OK')
          this.$router.replace({
            name: "signin"
          });
        })
        .onOk(() => {
          // console.log('>>>> second OK catcher')
        })
        .onCancel(() => {
          // console.log('>>>> Cancel')
        })
        .onDismiss(() => {
          // console.log('I am triggered on both OK and Cancel')
        });
    }
  }
};
